
import DealBannerContent from './DealBannerContent.vue';

export default {
  name: 'MobileDealBannerHeader',
  components: {
    DealBannerContent,
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
  },
};
